import React from 'react';
import GrandSlamLandingQuestionItem from 'app/components/landing_grand_slam/GrandSlamLandingQuestionItem';

interface Props {
    questions: {
        [date: string]: Question[]
    }
}

interface Question {
    id: number
    content: string
    content_langs: {
        [date: string]: string
    }
}

const getQuestions = (questionsProps: Props) => {
    const {questions} = questionsProps;

    if (questions) {
        return Object.keys(questions).map(key => ({date: key, questions: questions[key]}));
    }
    return [];
};

const GrandSlamLandingQuestion: React.FC<Props> = props => <div className="landing-promo-faq-list">
    {getQuestions(props)
        .map((questionItem, index) => <GrandSlamLandingQuestionItem
            key={`question-${index}`}
            questionItem={questionItem}
            numberDay={index + 1}
        />)}
</div>;

export default GrandSlamLandingQuestion;
